export const UNKNOWN_HOST = "http://localhost";
export const INIT_PATH = "/__vite_plugin_cloudflare_init__";

// headers
export const WORKER_ENTRY_PATH_HEADER = "__VITE_WORKER_ENTRY_PATH__";
export const IS_ENTRY_WORKER_HEADER = "__VITE_IS_ENTRY_WORKER__";

// virtual modules
export const virtualPrefix = "virtual:cloudflare/";
export const VIRTUAL_WORKER_ENTRY = `${virtualPrefix}worker-entry`;
